import {
  Image,
  Linking,
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { ShowLoader } from "../../../../common/ShowLoader";
import { getLoginData } from "../../../../utility/AppStoreData";
import PurchaseScreen from "../PurchaseScreen";
import PaymentScreen from "./PaymentScreen";
import { handleApiError } from "../../../../services/errorHandler";
import {
  fetchPaymentBeltExchange,
  fetchUserBalance,
} from "../../../../services/profileAPI";

export default function BuyBeltaModal(props) {
  const {
    showModal = false,
    setShowModal,
    selectedBelt,
    paymentAPIData,
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [beltSelected, setbeltSelected] = useState("");

  const [userData, setUserData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [paymentBeltExchangeData, setPaymentBeltExchangeData] = useState(null);
  const [paymentCreateSessionData, setPaymentCreateSessionData] =
    useState(null);

  const [paymentScreenModal, setPaymentScreenModal] = useState(false);

  function clickBelt(belt) {
    setbeltSelected(belt);
  }

  useEffect(() => {
    getLoginUserData();
  }, []);

  // useEffect(() => {
  //     const logCurrentUrl = () => {

  //         const currentUrl = new URL(window.location.href);

  //         if (currentUrl.searchParams.has('session_id')) {
  //             const sessionId = currentUrl.searchParams.get('session_id');

  //         }
  //     };

  //     // Log the current URL when the page loads
  //     logCurrentUrl();

  //     window.onpopstate = logCurrentUrl;

  //     // Clean up the event listener when the component unmounts
  //     return () => {
  //         window.onpopstate = null;
  //     };
  // }, []);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          {/* Header view */}
          <View style={styles.headerView}>
            <View style={{ flex: 1 }}>
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_32,
                  { color: AppColors.white },
                ]}
              >
                Buy Belts
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.white, marginTop: 5 },
                ]}
              >
                Select the belt you want to buy
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: AppColors.white,
                    textDecorationLine: "underline",
                    marginTop: 16,
                  },
                ]}
              >
                Learn about Belts system
              </Text>
            </View>
            <View
              style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Your tokens
              </Text>
              <View style={styles.tokenWrapper}>
                <View style={styles.tokenItemWrapper}>
                  <Image
                    source={AppImages.Ko_Token}
                    style={{
                      width: 19,
                      height: 19,
                      resizeMode: "contain",
                    }}
                  />
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_20,
                      {
                        color: AppColors.white,
                        marginEnd: 16,
                        alignSelf: "center",
                      },
                    ]}
                  >
                    {/* 40000000 */}
                    {userBalanceData?.balance}
                  </Text>
                </View>
                <Image
                  source={AppImages.icnAddToken}
                  style={{
                    width: 34,
                    height: 34,
                    marginVertical: 5,
                    resizeMode: "contain",
                  }}
                />
              </View>
            </View>
          </View>
          <View style={styles.divider} />
          <ScrollView>
            <View>
              {/* Body view */}
              <View style={styles.bodyView}>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_16,
                    { color: AppColors.white },
                  ]}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      {
                        color: AppColors.appViolentColor_6D08C3,
                      },
                    ]}
                  >
                    Note:{" "}
                  </Text>
                  You have to use tokens to buy the belts
                </Text>
                {/* Belts selection view */}

                {paymentBeltExchangeData && (
                  <View style={styles.beltView}>
                    <View style={styles.beltMainWrapper}>
                      {/* Bronze belt */}
                      <TouchableOpacity
                        style={[
                          styles.beltWrapper,
                          {
                            backgroundColor:
                              beltSelected === "Bronze"
                                ? AppColors.grayColor_999999
                                : AppColors.black_282828,
                          },
                        ]}
                        activeOpacity={0.5}
                        onPress={() => {
                          clickBelt("Bronze");
                        }}
                      >
                        <View
                          style={{
                            gap: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Get
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_20,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            Bronze
                          </Text>

                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            For
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_16,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            {/* 400 Tokens111 */}
                            {paymentBeltExchangeData.exchangeRates.bronze +
                              " Tokens"}
                          </Text>
                        </View>
                        <Image
                          source={AppImages.imgBronzeBelt}
                          style={{
                            width: 80,
                            height: 100,
                            marginStart: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      {/* Silver Belt */}
                      <TouchableOpacity
                        style={[
                          styles.beltWrapper,
                          {
                            backgroundColor:
                              beltSelected === "Silver"
                                ? AppColors.grayColor_999999
                                : AppColors.black_282828,
                          },
                        ]}
                        activeOpacity={0.5}
                        onPress={() => {
                          clickBelt("Silver");
                        }}
                      >
                        <View
                          style={{
                            gap: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Get
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_20,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            Silver
                          </Text>

                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            For
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_16,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            {/* 400 Tokens */}
                            {paymentBeltExchangeData.exchangeRates.silver +
                              " Tokens"}
                          </Text>
                        </View>
                        <Image
                          source={AppImages.imgSilverBelt}
                          style={{
                            width: 80,
                            height: 100,
                            marginStart: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={styles.beltMainWrapper}>
                      {/* Gold Belt */}
                      <TouchableOpacity
                        style={[
                          styles.beltWrapper,
                          {
                            backgroundColor:
                              beltSelected === "Gold"
                                ? AppColors.grayColor_999999
                                : AppColors.black_282828,
                          },
                        ]}
                        activeOpacity={0.5}
                        onPress={() => {
                          clickBelt("Gold");
                        }}
                      >
                        <View
                          style={{
                            gap: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Get
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_20,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            Gold
                          </Text>

                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            For
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_16,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            {/* 400 Tokens */}
                            {paymentBeltExchangeData.exchangeRates.gold +
                              " Tokens"}
                          </Text>
                        </View>
                        <Image
                          source={AppImages.imgGoldBelt}
                          style={{
                            width: 80,
                            height: 100,
                            marginStart: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                      {/* Platinum Belt */}
                      <TouchableOpacity
                        style={[
                          styles.beltWrapper,
                          {
                            backgroundColor:
                              beltSelected === "Platinum"
                                ? AppColors.grayColor_999999
                                : AppColors.black_282828,
                          },
                        ]}
                        activeOpacity={0.5}
                        onPress={() => {
                          clickBelt("Platinum");
                        }}
                      >
                        <View
                          style={{
                            gap: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Get
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_20,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            Platinum
                          </Text>

                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_10,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            For
                          </Text>
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_16,
                              {
                                color: AppColors.white,
                                marginStart: 23,
                              },
                            ]}
                          >
                            {/* 400 Tokens */}
                            {paymentBeltExchangeData.exchangeRates.platinum +
                              " Tokens"}
                          </Text>
                        </View>
                        <Image
                          source={AppImages.imgPlatinumBelt}
                          style={{
                            width: 80,
                            height: 100,
                            marginStart: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                )}
              </View>
            </View>
          </ScrollView>
          {/* Buy Button */}
          <View style={styles.buttonWrapper}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => {
                onCloseClick();
              }}
            >
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_12, styles.closeButtonText]}
              >
                Cancel
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.confirmButton}
              onPress={() => {
                //         // setPaymentScreenModal(true);

                //         // window.location.href = successData.url;

                //         // Linking.openURL(successData.url);

                //         // selectedBelt({
                //         //     token: 400,
                //         //     belt: "Bronze",
                //         // });
                //         // onCloseClick();

                //         paymentAPIData(successData);
                //         onCloseClick();
                //     }
                // });

                selectedBelt({
                  token: 400,
                  belt: "Bronze",
                });
                onCloseClick();
              }}
            >
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_12, styles.confirmButtonText]}
              >
                Confirm purchase
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>

      {/* Show Loader */}
      {<ShowLoader showIndicater={showLoader} />}
      {/* Payment Screen Modal */}
      {paymentScreenModal && (
        <PaymentScreen
          showModal={paymentScreenModal}
          setShowModal={setPaymentScreenModal}
          paymentCreateSessionData={paymentCreateSessionData}
          confirmSuccess={() => {
            // onCloseClick();
          }}
        />
      )}
    </Modal>
  );

  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);

      checkUserBalanceAPI(data.AccessToken);
      paymentBeltExchangeAPI(data.AccessToken);
    }
  }

  async function checkUserBalanceAPI(AccessToken) {
    setShowLoader(true);

    try {
      const response = await fetchUserBalance(AccessToken);
      setShowLoader(false);

      if (response.ok) {
        setUserBalanceData(response);
      } else {
        handleApiError(response.status, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  }

  async function paymentBeltExchangeAPI(AccessToken) {
    setShowLoader(true);

    try {
      const response = await fetchPaymentBeltExchange(AccessToken);
      setShowLoader(false);

      if (response.statusCode === 200) {
        setPaymentBeltExchangeData(response);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.info(error.message);
    }
  }
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "60%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
      borderRadius: 12,
      borderWidth: 1,
      borderColor: AppColors.buttonRed_DC2626,
    },
    divider: {
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    beltWrapper: {
      flex: 1,
      height: 160,
      flexDirection: "row",
      backgroundColor: AppColors.black_282828,
      borderRadius: 10,
      justifyContent: "center",
      alignItems: "center",
      rowGap: 16,
    },
    headerView: {
      marginTop: 16,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 10,
      gap: 10,
    },
    tokenWrapper: {
      backgroundColor: AppColors.black_282828,
      borderRadius: 8,
      paddingVertical: 5,
      paddingHorizontal: 16,
      marginTop: 12,
      flexDirection: "row",
      gap: 10,
    },
    tokenItemWrapper: {
      backgroundColor: AppColors.black_121212,
      borderRadius: 6,
      flexDirection: "row",
      gap: 10,
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 10,
      paddingVertical: 5,
    },
    beltMainWrapper: {
      flexDirection: "row",
      columnGap: 45,
    },
    bodyView: {
      marginTop: 16,
      paddingHorizontal: 26,
      marginBottom: 26,
    },
    beltView: {
      marginTop: 16,
      paddingHorizontal: 16,
      gap: 16,
    },
    buttonWrapper: {
      justifyContent: "flex-end",
      flexDirection: "row",
      gap: 10,
      marginBottom: 16,
      // height: 38,
    },
    closeButton: {
      borderRadius: 10,
      marginBottom: 15,
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 2,
      borderColor: AppColors.appViolentColor_6D08C3,
    },
    confirmButton: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      marginBottom: 15,
      justifyContent: "center",
      alignItems: "center",
    },
    closeButtonText: {
      paddingVertical: 12,
      paddingHorizontal: 65,
      color: AppColors.appViolentColor_6D08C3,
    },
    confirmButtonText: {
      paddingVertical: 8,
      paddingHorizontal: 50,
      color: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "65%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.buttonRed_DC2626,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      beltWrapper: {
        flex: 1,
        height: 160,
        flexDirection: "row",
        backgroundColor: AppColors.black_282828,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        rowGap: 16,
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      beltMainWrapper: {
        flexDirection: "row",
        columnGap: 35,
      },
      bodyView: {
        marginTop: 16,
        paddingHorizontal: 16,
        marginBottom: 26,
      },
      beltView: {
        marginTop: 16,
        paddingHorizontal: 16,
        gap: 16,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.appViolentColor_6D08C3,
      },
      confirmButton: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.appViolentColor_6D08C3,
      },
      confirmButtonText: {
        paddingVertical: 8,
        paddingHorizontal: 50,
        color: AppColors.white,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.buttonRed_DC2626,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      beltWrapper: {
        flex: 1,
        height: 160,
        flexDirection: "row",
        backgroundColor: AppColors.black_282828,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        rowGap: 16,
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      beltMainWrapper: {
        flexDirection: "row",
        columnGap: 25,
      },
      bodyView: {
        marginTop: 16,
        paddingHorizontal: 12,
        marginBottom: 26,
      },
      beltView: {
        marginTop: 16,
        paddingHorizontal: 16,
        gap: 16,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.appViolentColor_6D08C3,
      },
      confirmButton: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.appViolentColor_6D08C3,
      },
      confirmButtonText: {
        paddingVertical: 8,
        paddingHorizontal: 50,
        color: AppColors.white,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.buttonRed_DC2626,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      beltWrapper: {
        flex: 1,
        height: 160,
        flexDirection: "row",
        backgroundColor: AppColors.black_282828,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        rowGap: 16,
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      beltMainWrapper: {
        flexDirection: "row",
        columnGap: 25,
      },
      bodyView: {
        marginTop: 16,
        paddingHorizontal: 5,
        marginBottom: 26,
      },
      beltView: {
        marginTop: 16,
        paddingHorizontal: 10,
        gap: 16,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.appViolentColor_6D08C3,
      },
      confirmButton: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.appViolentColor_6D08C3,
      },
      confirmButtonText: {
        paddingVertical: 8,
        paddingHorizontal: 50,
        color: AppColors.white,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderWidth: 1,
        borderColor: AppColors.buttonRed_DC2626,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      beltWrapper: {
        flex: 1,
        flexDirection: "row",
        backgroundColor: AppColors.black_282828,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        rowGap: 16,
        paddingVertical: 16,
      },
      headerView: {
        marginTop: 16,
        flexDirection: "column",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      beltMainWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      bodyView: {
        marginTop: 16,
        paddingHorizontal: 1,
        marginBottom: 26,
      },
      beltView: {
        marginTop: 16,
        paddingHorizontal: 5,
        gap: 16,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        paddingTop: 10,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.appViolentColor_6D08C3,
      },
      confirmButton: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 35,
        color: AppColors.appViolentColor_6D08C3,
      },
      confirmButtonText: {
        paddingVertical: 8,
        paddingHorizontal: 20,
        color: AppColors.white,
      },
    },
  }
);
